export const CodeReportItem = (raw: ICodeReportApiItem): ICodeReportModel => ({
	id: raw.promotion_id,
	name: raw.name,
	campaignId: raw.campaign_id,
	campaignName: raw.campaign_name,
	codesSummary: raw.codes_summary,
	uses: raw.usages,
	orders: raw.orders,
	grossRevenue: raw.gross_revenue_cents,
	netRevenue: raw.net_revenue_cents,
	discountCost: raw.discount_cost_cents,
	aovWithCode: raw.aov_with_code_cents,
	aovWithoutCode: raw.aov_without_code_cents,
	newClientsPercent: raw.new_clients_percentage,
	return30dPercent: raw.return_30d_percentage,
	return60dPercent: raw.return_60d_percentage,
	return90dPercent: raw.return_90d_percentage,
})
